import { render, staticRenderFns } from "./SmsCode.vue?vue&type=template&id=456502f0&scoped=true"
import script from "./SmsCode.vue?vue&type=script&lang=js"
export * from "./SmsCode.vue?vue&type=script&lang=js"
import style0 from "./SmsCode.vue?vue&type=style&index=0&id=456502f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456502f0",
  null
  
)

export default component.exports